import ClayButton from "@clayui/button";
import ClayCard from "@clayui/card";
import ClayLayout from "@clayui/layout";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getBitnamiHomeElements, getBitnamiHomePage, getBitnamiHomeTotalElements } from "../../../../store/bitnamiHome/slice.es";
import { formatDate, formatToLowerCase, resolveTransforms, OFFERING_IMAGES } from "../../../constants/bitnamiHome/bitnamiHomeConstants.es";
import BitnamiHomeSearch from "../search/BitnamiHomeSearch.es";
import ClayBadge from "@clayui/badge";
import { Icon } from "common-ui-modules";
import { ClayTooltipProvider } from "@clayui/tooltip";

const BitnamiHome = ({ constructStackCategoryCardHref, fetchAppsPayload, setFetchAppsPayload, onInfoButtonClick, showAppInfoModal, isPreviewMode, bitnamiLogoBaseUrlPath }) => {

    const catalogList = useSelector(getBitnamiHomePage) || [];
    const numberOfElements = useSelector(getBitnamiHomeElements) || 0;
    const totalElements = useSelector(getBitnamiHomeTotalElements) || 0;

    const [hrefs, setHrefs] = useState({});

    //Checking for current stack selected, appending the value in hrefs of each application
    useEffect(() => {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const stack = params.get('stack');

        if (stack)
        {
            const newHrefs = {};
            catalogList.forEach((card) => {
                let href = isPreviewMode === "true"
                    ? `/group/developerauthor/stacks/preview?id=${ card.applicationID }`
                    : `/stack/${ card.permalink }`;

                if (stack)
                {
                    href += href.includes('?') ? `&offering=${ stack }` : `/${ stack }`;
                }

                newHrefs[card.permalink] = href;
            });
            setHrefs(newHrefs);
        } else
        {
            const newHrefs = {};
            catalogList.forEach((card) => {
                let href = isPreviewMode === "true"
                    ? `/group/developerauthor/stacks/preview?id=${ card.applicationID }`
                    : `/stack/${ card.permalink }`;

                newHrefs[card.permalink] = href;
            });
            setHrefs(newHrefs);
        }
    }, [catalogList, isPreviewMode]);

    return (
        <React.Fragment>
            <BitnamiHomeSearch fetchAppsPayload={fetchAppsPayload} setFetchAppsPayload={setFetchAppsPayload} />
            <div className="tools-container">
                <ClayLayout.Row justify="start">
                    {
                        catalogList?.map((card) => {
                            const href = hrefs[card.permalink];

                            return (
                                <ClayLayout.Col size={12}
                                    md={6}
                                    lg={4}
                                    xl={3}
                                    className='mb-4'
                                    key={card.shortName}>
                                    <ClayCard className="card shadow d-flex flex-column h-100">
                                        <ClayCard.Body className='catalog-card-body d-flex flex-column m-3'>
                                            {isPreviewMode === "true" && (
                                                <ClayLayout.Row className={`align-items-start d-flex justify-content-between p-2 mb-3 ${ card.status.toLowerCase() }-status`}>
                                                    <ClayLayout.Col className="offset-4 pl-0">
                                                        <ClayBadge
                                                            displayType="secondary"
                                                            label={card.status ? card.status.toUpperCase() : ""}
                                                            className={`${ card.status.toLowerCase() }-status`}
                                                        />
                                                    </ClayLayout.Col>
                                                    <ClayLayout.Col className="d-flex justify-content-end pr-4">
                                                        <ClayTooltipProvider>
                                                            <ClayButton
                                                                className="p-0 pl-1 m-0"
                                                                displayType="link"
                                                                data-tooltip-align={"top"}
                                                                title={"More Information"}
                                                                onClick={() => {
                                                                    showAppInfoModal();
                                                                    onInfoButtonClick([
                                                                        { applicationName: resolveTransforms(card.shortName), updatedTime: formatDate(card.lastUpdateDate), updatedBy: card.lastUpdatedBy }
                                                                    ]);
                                                                }}
                                                                tabIndex="-1"
                                                            >
                                                                <Icon type="info" />
                                                            </ClayButton>
                                                        </ClayTooltipProvider>
                                                    </ClayLayout.Col>
                                                </ClayLayout.Row>
                                            )}
                                            <ClayLayout.Row className="flex-grow-1 ">
                                                <ClayLayout.Col size={4} className="d-flex justify-content-center align-items-start">
                                                    <a data-senna-off href={href}>
                                                        {card?.logoRelativePath === null ? (
                                                            <Icon type="defaultBitnamiLogoIcon" height="60" width="60" />
                                                        ) : (
                                                            <img src={`${ bitnamiLogoBaseUrlPath + card?.logoRelativePath }`} alt={'no-image-found'} height="60" width="60" />
                                                        )}
                                                    </a>
                                                </ClayLayout.Col>
                                                <ClayLayout.Col size={8} className='pl-0'>
                                                    <a data-senna-off href={href}>
                                                        <ClayLayout.Row>
                                                            <ClayLayout.Col>
                                                                <h3>{resolveTransforms(card.shortName)}</h3>
                                                            </ClayLayout.Col>
                                                        </ClayLayout.Row>
                                                        <ClayLayout.Row className="mb-2">
                                                            <ClayLayout.Col>
                                                                <p className="text-muted mb-0 mt-0">{resolveTransforms(card.fullName)}</p>
                                                            </ClayLayout.Col>
                                                        </ClayLayout.Row>
                                                    </a>
                                                </ClayLayout.Col>
                                                <ClayLayout.Col className="mt-auto offset-4 pl-0" size={8}>
                                                    <ClayLayout.Row className="d-flex flex-column">
                                                        <ClayLayout.Col>
                                                            {card.tags && (
                                                                <a
                                                                    data-senna-off
                                                                    href={constructStackCategoryCardHref(card.tags.split(',')[0].trim(), false)}
                                                                    className="pl-0 pb-0 mb-3 category-button"
                                                                >
                                                                    {card.tags?.split(',')[0].trim()}
                                                                </a>
                                                            )}
                                                        </ClayLayout.Col>
                                                    </ClayLayout.Row>
                                                </ClayLayout.Col>
                                            </ClayLayout.Row>
                                        </ClayCard.Body>
                                    </ClayCard>
                                </ClayLayout.Col>
                            );
                        })
                    }
                    {(totalElements - numberOfElements) > 0 && (
                        <ClayLayout.Col size={12}
                            md={6}
                            lg={4}
                            xl={3} className='mb-3'>
                            <ClayCard className="h-100 bg-light d-flex align-items-center shadow">
                                <ClayCard.Body className='catalog-card-body'>
                                    <ClayButton displayType="unstyled" className="w-100 h-100 p-0 d-flex justify-content-center" onClick={() => setFetchAppsPayload({ ...fetchAppsPayload, pageSize: totalElements + 1 })} >
                                        <h3>+{totalElements - numberOfElements} More Applications</h3>
                                    </ClayButton>
                                </ClayCard.Body>
                            </ClayCard>
                        </ClayLayout.Col>
                    )}
                </ClayLayout.Row>
            </div>
        </React.Fragment>
    );
};

export default BitnamiHome;